var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('Loader'),_c('custom-notification'),_c('custom-confirmation'),_c('side-bar',{attrs:{"drawer":_vm.drawer}}),_c('top-nav',{attrs:{"drawer":_vm.drawer},on:{"update:drawer":function($event){_vm.drawer=$event}}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }